/* global PROD_ENV */
import braintree from 'braintree-web'
import logger from './logger'

const addFraudProtection = (
  callback,
  callbackArgs,
  clientToken,
  showFraudProtectionError
) => {
  braintree.client
    .create({
      authorization: clientToken
    })
    .then((clientInstance) =>
      braintree.dataCollector
        .create({
          client: clientInstance,
          kount: false
        })
        .then((dataCollectorInstance) => {
          const { deviceData } = dataCollectorInstance
          callback(deviceData, ...callbackArgs)
        })
        .catch((err) => {
          // Never proceed silently: the callback is the only path that
          // submits, and a submission without device data is
          // indistinguishable from carding traffic at the edge. Block the
          // submit and tell the user, mirroring the client-creation catch.
          showFraudProtectionError()
          logger.error(`[Braintree] Error in data collector creation: ${err}`)
        })
    )
    .catch((err) => {
      showFraudProtectionError()
      if (PROD_ENV)
        logger.error(`[Braintree] Error in creation of components: ${err}`)
    })
}

export default addFraudProtection
